function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M437.328,42.651h-128c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667h128 c5.888,0,10.667-4.779,10.667-10.667S443.216,42.651,437.328,42.651z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M444.88,45.787L402.213,3.12c-4.16-4.16-10.923-4.16-15.083,0c-4.16,4.16-4.16,10.923,0,15.083l35.115,35.115 l-35.136,35.136c-4.16,4.16-4.16,10.923,0,15.083c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.552-3.115 l42.667-42.667C449.04,56.709,449.04,49.947,444.88,45.787z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M159.995,42.651h-128c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667h128 c5.888,0,10.667-4.779,10.667-10.667S165.883,42.651,159.995,42.651z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M47.077,53.317l35.115-35.115c4.16-4.16,4.16-10.923,0-15.083c-4.16-4.16-10.923-4.16-15.083,0L24.443,45.787 c-4.16,4.16-4.16,10.923,0,15.083l42.667,42.667c2.091,2.069,4.821,3.115,7.552,3.115c2.731,0,5.461-1.045,7.531-3.136 c4.16-4.16,4.16-10.923,0-15.083L47.077,53.317z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M426.661,213.317c-8.768,0-16.939,2.667-23.723,7.211c-5.845-16.597-21.696-28.544-40.277-28.544 c-8.768,0-16.939,2.667-23.723,7.211c-5.845-16.597-21.696-28.544-40.277-28.544c-7.765,0-15.061,2.091-21.333,5.739v-69.739 c0-23.531-19.136-42.667-42.667-42.667c-23.531,0-42.667,19.136-42.667,42.667v181.333l-37.077-27.797 c-21.973-16.491-53.248-14.293-72.725,5.163c-12.48,12.48-12.48,32.768,0,45.248l151.915,151.936 c18.133,18.133,42.261,28.117,67.904,28.117h49.984c64.683,0,117.333-52.629,117.333-117.333V255.984 C469.328,232.453,450.192,213.317,426.661,213.317z M447.995,373.317c0,52.928-43.072,96-96,96h-49.984 c-19.968,0-38.72-7.765-52.821-21.867L97.275,295.515c-4.16-4.16-4.16-10.923,0-15.083c6.613-6.592,15.445-9.984,24.32-9.984 c7.211,0,14.464,2.24,20.544,6.805l54.123,40.597c3.243,2.432,7.595,2.795,11.179,1.003c3.605-1.813,5.888-5.504,5.888-9.536 V106.651c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333v160c0,5.888,4.779,10.667,10.667,10.667 s10.667-4.779,10.667-10.667v-53.333c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333v53.333 c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667v-32c0-11.755,9.557-21.333,21.333-21.333 s21.333,9.579,21.333,21.333v32c0,5.888,4.779,10.667,10.667,10.667c5.888,0,10.667-4.779,10.667-10.667v-10.667 c0-11.755,9.557-21.333,21.333-21.333s21.333,9.579,21.333,21.333V373.317z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.651 490.651",
    style: {
      "enableBackground": "new 0 0 490.651 490.651"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

export default __webpack_public_path__ + "static/media/swipe.674ec961.svg";
export { SvgComponent as ReactComponent };